import { render, staticRenderFns } from "./PromoteDailyData.vue?vue&type=template&id=f1248a56"
import script from "./PromoteDailyData.vue?vue&type=script&lang=ts"
export * from "./PromoteDailyData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports